export default "__VITE_ASSET__ChC7Knf0__"